import { render } from "./ProductCategory.vue?vue&type=template&id=3a56142b&scoped=true"
import script from "./ProductCategory.vue?vue&type=script&lang=js"
export * from "./ProductCategory.vue?vue&type=script&lang=js"

import "./ProductCategory.vue?vue&type=style&index=0&id=3a56142b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a56142b"]])

export default __exports__